import React from 'react';
import {
    GetStageSheet_getStageSheet_propDetails as ProppantDetailsType,
    GetStageSheet_getStageSheet_details as StageSheet,
} from '../../../../types/schemaTypes';
import './StageSheet.scss';
import {NumericFormat as NumberFormat} from 'react-number-format';

export interface PrintStageSheetProps {
    jobName: string;
    wellheadStages: string;
    proppantDetails: ProppantDetailsType[] | undefined;
    stageSheets: StageSheet[] | undefined;
    innerRef?: React.RefObject<HTMLDivElement | null>;
}

export class StageSheetBellyDumpPrintAllLayout extends React.Component<PrintStageSheetProps> {
    public render() {
        const { jobName, wellheadStages, proppantDetails, stageSheets, innerRef } = this.props;
        return (
            <div ref={innerRef}>
                <div className="StageSheet-Header-To-Print">
                    {jobName} - {wellheadStages}
                </div>

                <div className="StageSheet-Grid-Container-To-Print">
                    <table className="StageSheet-Grid-To-Print">
                        <thead>
                            <tr>
                                <th>Proppant</th>
                                <th>Total Weight Needed</th>
                                <th>Sand Pumped</th>
                                <th>Cumulative Box Weight</th>
                            </tr>
                        </thead>

                        <tbody className="StageSheet-Row-To-Print">
                            {proppantDetails &&
                                proppantDetails.map((proppantDetail, index) => (
                                    <tr
                                        key={index}
                                        style={{ backgroundColor: `${index % 2 === 0 ? '#f2f2f2' : '#fff'}` }}
                                    >
                                        <td>{proppantDetail.proppantName}</td>
                                        <td
                                            className={
                                                proppantDetail.totalWeightNeeded && proppantDetail.totalWeightNeeded < 0
                                                    ? 'Td-Red-Background'
                                                    : ''
                                            }
                                        >
                                            <NumberFormat
                                                value={proppantDetail.totalWeightNeeded || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </td>
                                        <td>
                                            <NumberFormat
                                                value={proppantDetail.sandPumped || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </td>
                                        <td>
                                            <NumberFormat
                                                value={proppantDetail.totalBoxWeight || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>

                <div className="StageSheet-Grid-Container-To-Print">
                    <table className="StageSheet-Grid-To-Print">
                        <thead>
                            <tr>
                                <th>Station #</th>
                                <th>Box</th>
                                <th>Weight</th>
                                <th>Accumulated Weight</th>
                                <th>Type</th>
                                <th>Pad Location</th>
                                <th>Wt. Remaining</th>
                                <th>OOS</th>
                                <th>PO #</th>
                                <th>Load #</th>
                                <th>SandTicket #</th>
                                <th>ST Weight</th>
                                <th>ST Wt. Remaining</th>
                            </tr>
                        </thead>

                        <tbody className="StageSheet-Row-To-Print">
                            {stageSheets &&
                                stageSheets.map((stageSheet, index) => (
                                    <>
                                    {stageSheet.stageSheetBellyDump?.map((load, loadIndex) => (
                                    <tr
                                        key={index}
                                        style={{ backgroundColor: `${index % 2 === 0 ? '#f2f2f2' : '#fff'}` }}
                                    >
                                        {loadIndex === 0 && (
                                            <>
                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.station === '0' ? '' : stageSheet.station}</td>
                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                            <div className="StageSheet-GreenDot-Container">
                                                {stageSheet.boxDesc}
                                                {stageSheet.isPartial === 'Yes' && (
                                                    <div className="StageSheet-GreenDot" />
                                                )}
                                            </div>
                                        </td>
                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                            <NumberFormat
                                                value={stageSheet.boxWeight || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </td>
                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                            <NumberFormat
                                                value={stageSheet.accumulatedWeight || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </td>
                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.proppant}</td>
                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.location}</td>
                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>
                                            <NumberFormat
                                                value={stageSheet.boxWeightRemaining || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                            />
                                        </td>
                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.isOOS ? 'Yes' : 'No'}</td>
                                        <td rowSpan={stageSheet.stageSheetBellyDump?.length}>{stageSheet.sandPo}</td>
                                        </>
                                    )}
                                        <td>{load?.loadId}</td>
                                        <td>{load?.sandTicket}</td>
                                        <td>{load?.sandTicketWeight}</td>
                                        <td>{load?.sandTicketWeightRemaining}</td>
                                    </tr>
                                    ))}
                                    </>
                                ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
